import { render } from "./SelectLocationComponent.vue?vue&type=template&id=56d51970&scoped=true"
import script from "./SelectLocationComponent.vue?vue&type=script&lang=js"
export * from "./SelectLocationComponent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-56d51970"

export default script